import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_DATA} from '../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../utils/capitalize";
import {getLoanApplicationReport} from "../../api/app";
import 'react-quill/dist/quill.snow.css';
import formatNumber from "../../utils/formatNumber";

const generateHtmlContent = (data) => {
    return(
        `<!DOCTYPE html>
            <html>
            <head>
            <meta charset="utf-8">
                <title>CEEC BUSULU LOAN PRODUCT</title>
            <style>
                @page { size: A4; margin: 25mm 20mm; }
                body { font-family: Arial, Helvetica, sans-serif; }
                table { border-collapse: collapse; width: 100%; margin-bottom: 18px; page-break-inside: avoid; }
                td, th { border: 1px solid #000; padding: 8px; vertical-align: top; font-size: 13px; }
                .ceec-header { text-align: center; }
                .ceec-logo { height: 50px; }
                .ceec-title { font-size: 20px; font-weight: bold; color: #0b5ea8; }
                .ceec-subtitle { font-size: 14px; font-weight: bold; color: #000000; margin-bottom: 5px }
            </style>
        
            <style>
                /* Screen A4 page view */
                @media screen {
                body {
                background: #e9ecef;
                margin: 0;
                padding: 24px 0;
            }
                .a4-page {
                width: 210mm;
                min-height: 297mm;
                margin: 0 auto 24px auto;
                background: #ffffff;
                box-shadow: 0 6px 24px rgba(0,0,0,0.15);
                padding: 18mm 20mm 25mm 20mm;
            }
            }
        
                .pdf-toolbar {
                text-align: center;
                margin-bottom: 16px;
            }
        
                .pdf-btn {
                background: #0b5ea8;
                color: #fff;
                border: none;
                padding: 10px 18px;
                font-size: 14px;
                cursor: pointer;
                border-radius: 4px;
            }
        
                .pdf-btn:hover {
                background: #094c88;
            }
        
                .signature-row {
                display: flex;
                justify-content: space-between;
            }
        
                .signature-left,
                .signature-right {
                width: 45%;
                font-size: 13px;
            }
        
                .signature-line,
                .date-line {
                display: inline-block;
                width: 100%;
                border-bottom: 1px solid #000;
                height: 20px;
                margin-top: 36px;
            }
        
                .signature-picture {
                border-bottom: 1px solid #000;
                height: 43px;
            }
        
                /* Print A4 */
                @media print {
        
                html, body {
                width: 210mm;
                height: 297mm;
                margin: 0 !important;
                padding: 0 !important;
            }
        
                @page {
                size: A4;
                margin: 0;
            }
        
                body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        
                .a4-page {
                width: 210mm;
                height: 297mm;          /* 🔴 FIXED HEIGHT (critical) */
                margin: 0;
                padding: 18mm 20mm 25mm 20mm;
                box-shadow: none;
                overflow: hidden;       /* 🔴 prevents reflow */
                page-break-after: always;
            }
        
                .no-print {
                display: none !important;
                visibility: hidden !important;
                height: 0 !important;
                overflow: hidden !important;
            }
            }
            </style>
        
        </head>
            <body>
            <div class="pdf-toolbar">
                <button class="pdf-btn no-print" onclick="window.print()">
                    ⬇ Download as PDF
                </button>
            </div>
            <div class="a4-page">
                <div class="ceec-header">
                    <img src="http://www.ceec.org.zm/wp-content/uploads/2018/07/ceeclogo.png" class="ceec-logo"/>
                    <div class="ceec-subtitle">MICROFINANCE LOAN PRODUCT - APPLICATION FORM</div>
                </div>
                <table>
                    <tr style="background-color: #D9D9D9">
                        <td><strong>1.0 APPLICANT INFORMATION</strong></td>
                        <td colspan="5"></td>
                    </tr>
                    <tr>
                        <td><strong>1.1 Name of Individual applying</strong></td>
                        <td colspan="5">${capitalize(data.user.name)}</td>
                    </tr>
                    <tr>
                        <td>a. Date of Birth of Applicant </td>
                        <td colspan="5">${data.user.dob}</td>
                    </tr>
                    <tr>
                        <td>b. NRC Number </td>
                        <td colspan="5">${capitalize(data.user.id_number)}</td>
                    </tr>
                    <tr>
                        <td>c. Physical Address or Residential Address </td>
                        <td colspan="5">${data.physical_address}</td>
                    </tr>
                    <tr>
                        <td>d. District </td>
                        <td colspan="5">${data.user.location?.district?.name || "n/a"}</td>
                    </tr>
                    <tr>
                        <td>e. Constituency</td>
                        <td colspan="5">${data.user.location?.constituency?.name || "n/a"}</td>
                    </tr>
                    <tr>
                        <td>f. Applicants Contact Number (linked to Airtel, MTN and ZAMTEL Mobile Money). <strong>Please note that the contact number must be registered in the Applicant name</strong></td>
                        <td colspan="5">${data.user.mobile_number || "n/a"}</td>
                    </tr>
                    <tr>
                        <td rowspan="2" style="width:45%; vertical-align:top;">
                            g. Social Distribution (Primarily targeting youths and women in rural and peri-urban areas)
                        </td>
                        <td>Youth-Female</td>
                        <td>Youth-Male</td>
                        <td>Women</td>
                        <td>Disabled</td>
                        <td>Men</td>
                    </tr>
                    <tr>
                        <td>&nbsp;${data.user.gender === "female" ? "X" : ""}</td>
                        <td>&nbsp;${data.user.gender === "male" ? "X" : ""}</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td rowspan="3">
                            h. Next of Kin details
                        </td>
                        <td>Name</td>
                        <td colspan="4">${data?.next_of_kin?.name}&nbsp;</td>
                    </tr>
                    <tr>
                        <td>Mobile Number</td>
                        <td colspan="4">${data?.next_of_kin?.mobile_number}&nbsp;</td>
                    </tr>
                    <tr>
                        <td>Physical Address</td>
                        <td colspan="4">${data?.next_of_kin?.physical_address}&nbsp;</td>
                    </tr>
                </table>
        
                <table>
                    <tr style="background-color: #D9D9D9">
                        <td colspan="2"><strong>2.0 BUSINESS AND FINANCIAL INFORMATION</strong></td>
                    </tr>
                    <tr>
                        <td>Please indicate the sector for your proposed business ( tick where applicable)</td>
                        <td>
                            <label>Agriculture ${data.business.sector === "agriculture" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Manufacturing ${data.business.sector === "manufacturing" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Trading ${data.business.sector === "trading" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>ICT ${data.business.sector === "ict" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Services ${data.business.sector === "services" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Mining ${data.business.sector === "mining" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Energy ${data.business.sector === "energy" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Tourism ${data.business.sector === "tourism" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Construction <${data.business.sector === "construction" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>
                        </td>
                    </tr>
                    <tr>
                        <td>Is your business currently operational </td>
                        <td>${data.business.operational ? "Yes" : "No"}</td>
                    </tr>
                    <tr>
                        <td><strong>If yes:</strong></td>
                        <td></td>
                    </tr>
                    <tr> 
                        <td>How much do you make per month?</td>
                        <td><strong>ZMW</strong> ${data.business.operational ? data.business?.metadata?.monthly_income : ""}</td>
                    </tr>
                    <tr>
                        <td>How much do you spend per month on your business?</td>
                        <td><strong>ZMW</strong> ${data.business.operational ? data.business?.metadata?.monthly_expenses : ""}</td>
                    </tr>
                    <tr>
                        <td>How much did you spend to start your business? i.e. Capital</td>
                        <td><strong>ZMW</strong> ${data.business.operational ? data.business?.metadata?.projected_sales : ""}</td>
                    </tr>
                    <tr>
                        <td>How much will be your sales per month after the loan?</td>
                        <td><strong>ZMW</strong> ${data.business.operational ? data.business?.metadata?.startup_capital : ""}</td>
                    </tr>
                </table>
        
                <table>
                    <tr style="background-color: #D9D9D9">
                        <td colspan="3"><strong>3.0 INFORMATION ON JOB CREATION</strong></td>
                    </tr>
                    <tr>
                        <td rowspan="2" style="width:45%; vertical-align:top;">Number of Workers ( including self-employment)</td>
                        <td><strong>Before CEEC Loan</strong></td>
                        <td><strong>After CEEC Loan</strong></td>
                    </tr>
                    <tr>
                        <td>${data?.metadata?.number_of_worker}&nbsp;</td>
                        <td>${data?.metadata?._number_of_worker}&nbsp;</td>
                    </tr>
                </table>
        
                <table>
                    <tr style="background-color: #D9D9D9">
                        <td colspan="2"><strong>4.0 THE LOAN</strong></td>
                    </tr>
                    <tr>
                        <td>Indicate the loan amount applied for <strong>(K5,000 to K50,000)<br>NB: Higher loan amount within the loan threshold will be subjected to further due diligence to determine financing needs</strong></td>
                        <td><strong>ZMW</strong> ${formatNumber(data.amount)}</td>
                    </tr>
                </table>
        
                <div class="signature-row">
                    <div class="signature-left">
                        <strong>Applicant Signature:</strong><br/><br/>
                        <img src=${data?.metadata?.signature} class="signature-picture"/>
                    </div>
        
                    <div class="signature-right">
                        <strong>Date:</strong>
                        <span class="date-line">${moment(data.createdAt).format("DD.MM,YYYY")}</span>
                    </div>
                </div>
            </div>
            </body></html>`
    )
}

const Application = () => {

    document.title = "Application";

    const token = localStorage.getItem('jwtToken');
    const [reset, setReset] = useState(new Date().getTime());

    useEffect(() => {
        getLoanApplicationReport().then((response) => {
            if(!response.error) {
                $('#total-count').text(formatNumber(response.payload.total, "digit"));
                $('#total-pending').text(formatNumber(response.payload.pending, "digit"));
                $('#total-approved').text(formatNumber(response.payload.approved, "digit"));
                $('#total-rejection').text(formatNumber(response.payload.rejection, "digit"));
            }
        });
    }, [reset]);

    useEffect(() => {
        let table = $('#application').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Loan Application Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "application",
                        fieldname: "amount",
                        pageSize: data.start,
                        format: 'json',
                        populate: [
                            {
                                path: "user",
                                model: "user",
                                populate: [
                                    {
                                        path: 'location.provincial',
                                        model: 'administrative'
                                    },
                                    {
                                        path: 'location.constituency',
                                        model: 'constituency'
                                    },
                                    {
                                        path: 'location.district',
                                        model: 'district'
                                    }
                                ]
                            }
                        ],
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];

                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data?.user?.name ? capitalize(data.user.name) : `<span class="tx-danger">No Data</span>`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return formatNumber(data.amount);
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data.business.sector);
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return {
                            "pending" : `<span class="badge badge-success tx-white">Pending</span>`,
                            "approved" : `<span class="badge badge-primary tx-white">Approved</span>`,
                            "rejection" : `<span class="badge badge-primary tx-white">Rejection</span>`
                        }[data.status];
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 5
                }
            ]
        });

        $('#application tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            const { raw } = d;
            const op = !!raw?.business?.operational;

            const rows = [
                row('Personal Information:', [
                    'Legal Name: ' + capitalize(raw.user.name),
                    'Gender: ' +capitalize(raw.user.gender),
                    'Mobile Number: ' +raw.user.mobile_number,
                    'NRC Number: ' + raw.user.id_number,
                    'Province: ' + raw.user.location?.provincial?.name || "No Province",
                    'District: ' + raw.user.location?.district?.name || "No District",
                    'Constituency: ' + raw.user.location?.constituency?.name || "No Constituency",
                ].join('<br/>')),
                row('NRC Document:', [
                    'Photo 1: ' + `<a href='${raw.user.documents[0].uri}' class="text-secondary" target="_blank"><i class="fa fa-eye"></i> View NRC Front</a>` ,
                    'Photo 2: ' + `<a href='${raw.user.documents[1].uri}' class="text-secondary" target="_blank" href=""><i class="fa fa-eye"></i> View NRC Back</a>` ,
                ].join('<br/>')),
                row('Business Operational:', op ? 'Yes' : 'No'),
                op && row('Business:', [
                    'How much do you make per month: K' + formatNumber(raw?.business.metadata.monthly_income),
                    'How much do you spend per month on your business: K' + formatNumber(raw.business.metadata.monthly_expenses),
                    'How much did you spend to start your business: K' + formatNumber(raw.business.metadata.startup_capital),
                    'How much wil be your sales per month after the loan: K' + formatNumber(raw.business.metadata.projected_sales),
                ].join('<br/>')),
                row('Next Of Kin:', [
                    'Name: ' +raw?.next_of_kin?.name,
                    'Mobile Number: ' +raw?.next_of_kin?.mobile_number,
                    'Physical Address: ' +raw?.next_of_kin?.physical_address,
                ].join('<br/>')),
                row('Business Reference:', [
                    'Name: ' +raw.reference.name,
                    'Mobile Number: ' +raw.reference.mobile_number,
                    'Physical Address: ' +raw.reference.physical_address,
                ].join('<br/>')),
                row('Job Creation:', [
                    'Before CEEC: ' + (raw.metadata?.number_of_worker ?? '0'),
                    'After CEEC: '  + (raw.metadata?._number_of_worker ?? '0')
                ].join('<br/>')),
                actionRow(raw), // always included
            ].filter(Boolean).join('');

            return `
                <table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">
                  ${rows}
                </table>
              `;

            function row(label, html) {
                return `
                  <tr>
                    <td class="tx-semibold">${label}</td>
                    <td>${html}</td>
                  </tr>
                `;
            }

            function actionRow(data) {
                window.previewDoc = function () {
                    const htmlContent = generateHtmlContent(data);
                    const newWindow = window.open();
                    newWindow.document.open();
                    newWindow.document.write(htmlContent);
                    newWindow.document.close();
                };

                return `
                  <tr>
                    <td class="tx-13 pd-0" colspan="2">
                      <div class="d-flex">Action:
                        <a href="javascript:void(0)" class="nav-link pd-t-0 pd-l-5 mark-paid-waste" onclick="previewDoc()">
                          <i class="fa fa-eye"></i> View Document
                        </a>
                      </div>
                    </td>
                  </tr>
                `;
            }
        }

        return () => {
            table.destroy();
        }

    }, []);

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Loan Application</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Loan Application</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-3">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Loan Applications</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-count" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Pending</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-pending" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-success tx-semibold mg-b-8">Total Approved</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-approved" className="tx-normal tx-success mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-danger tx-semibold mg-b-8">Total Rejection</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-rejection" className="tx-normal tx-danger mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Loan Application List</h6>
                                <div className="d-flex tx-18">
                                    <a href="#" onClick={(e) => {
                                        setReset(new Date().getTime());
                                        e.preventDefault(); $('#application').DataTable().ajax.reload()}
                                    } className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="application" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Amount</th>
                                        <th className="wd-20p">Sector</th>
                                        <th className="wd-20p">Status</th>
                                        <th className="wd-20p">Date</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Application;
